/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Color } from 'csstype'
import { Fragment } from 'react'
import { CidadaoListagemDiabetesQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection } from './AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection'
import { AcompanhamentoCondicaoSaudeExamesAccordionSection } from './AcompanhamentoCondicaoSaudeExamesAccordionSection'

interface AcompanhamentoCondicaoSaudeDiabetesAccordionPanelProps {
  row: Readonly<CidadaoListagemDiabetesQueryModel>
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDiabetesAccordionPanel({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDiabetesAccordionPanelProps>) {
  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeAcompanhamentoDiabetesSection
        dataUltimaConsulta={row?.cidadao?.cidadaoConsolidado?.diabetes?.dataUltimaConsulta}
        qtdConsultas={row?.cidadao?.cidadaoConsolidado?.diabetes?.qtdConsultas ?? 0}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeExamesAccordionSection
        exames={row?.cidadao?.cidadaoConsolidado?.diabetes?.exames}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={
          row?.cidadao?.cidadaoConsolidado?.diabetes?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
        }
        qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado?.diabetes?.visitaDomiciliar?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </Fragment>
  )
}
